import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import "./courseDetails.css"
import { fetchCourseDetail } from '../../../service/course';
import apiFunctions from '../../../service/axiosConfig/apiFunctions';
import { baseUrl } from '../../../constants';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';

const CourseDetails = () => {
    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null); const [selectedFileB, setSelectedFileB] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null); const [previewUrlB, setPreviewUrlB] = useState(null);
    const [fileP_path, setFileP_path] = useState('')
    const [fileP_pathB, setFileP_pathB] = useState('')
    const [fileV_path, setFileV_path] = useState('')
    const [selectedVFile, setSelectedVFile] = useState(null);
    const [previewVUrl, setPreviewVUrl] = useState(null);
    const [previewDataVUrl, setPreviewDataVUrl] = useState(null);
    const [Upload, setUpload] = useState(false)
    const [UploadB, setUploadB] = useState(false)
    const [UploadV, setUploadV] = useState(false)
    const [courseName, setCourseName] = useState('')
    const [courseID, setCourseId] = useState('')
    const [loader, setLoader] = useState(false);
    const [isMicroModule, setIsMicroModule] = useState(false);

    // Helper function to get language-specific sessionStorage keys
    const getLanguageSpecificKey = (baseKey) => {
        const currentCourseId = sessionStorage.getItem("courseId");
        return `${baseKey}_${currentCourseId}`;
    };

    const [courseData, setCourseData] = useState({
        courseTitle: '',
        courseTagline: '',
        duration: '',
        skillset: '',
        editorContent: '',
        additionalEditors: ['']
    });
    const handleFileChangeB = (event) => {
        const file = event.target.files[0];
        setSelectedFileB(file);
        setUploadB(true)
        // Show preview
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrlB(reader.result);
            };
            reader.readAsDataURL(file);
            // handleImageUpload()
        } else {
            setPreviewUrlB(null);
        }
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        setUpload(true)
        // Show preview
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
            // handleImageUpload()
        } else {
            setPreviewUrl(null);
        }
    };

    const handleImageUpload = async () => {
        if (!selectedFile) {
            // alert('Please select an image');
            CustomToast.info('Please select an image')
            return;
        }

        try {
            // Calling the new function to upload the image
            const result = await apiFunctions.uploadImage(`${baseUrl}uploadImage`, selectedFile);
            setFileP_path(result.data.file_path)
            sessionStorage.setItem(getLanguageSpecificKey('imageData'), JSON.stringify(result.data.file_path))
            setUpload(false)
            CustomToast.success('File uploaded successfully')
        } catch (error) {
            console.error('Image upload error:', error);
            CustomToast.error('Error while uploading file')
        }
    };
    const handleImageUploadB = async () => {
        if (!selectedFileB) {
            // alert('Please select an image');
            CustomToast.info('Please select an image')
            return;
        }

        try {
            // Calling the new function to upload the image
            const result = await apiFunctions.uploadImage(`${baseUrl}uploadImage`, selectedFileB);
            setFileP_pathB(result.data.file_path)
            sessionStorage.setItem(getLanguageSpecificKey('imageDataB'), JSON.stringify(result.data.file_path))
            setUploadB(false)
            CustomToast.success('File uploaded successfully')
        } catch (error) {
            console.error('Image upload error:', error);
            CustomToast.error('Error while uploading file')
        }
    };

    const handleFileVChange = (event) => {
        const file = event.target.files[0];

        setSelectedVFile(file);
        setPreviewDataVUrl('')
        setUploadV(true)
        // Show preview
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewVUrl(reader.result);

            };
            reader.readAsArrayBuffer(file);
            // handleVideoUpload()
        } else {
            setPreviewVUrl(null);
        }
    };

    const handleRemoveVideo = (event) => {
        setPreviewDataVUrl('')
        setFileV_path('')
        setPreviewVUrl('')
        setSelectedVFile('')
        sessionStorage.removeItem(getLanguageSpecificKey("videoData"));
    }

    const handleRemoveImage = (event) => {
        setFileP_path('')
        setPreviewUrl('')
        setSelectedFile('')
        sessionStorage.removeItem(getLanguageSpecificKey("imageData"));
    }

    const handleRemoveImageUploadB = (event) => {
        setFileP_pathB('')
        setPreviewUrlB('')
        setSelectedFileB('')
        sessionStorage.removeItem(getLanguageSpecificKey("imageDataB"));
        // Clear the file input
        const inputElement = document.querySelector("input[name='bannerUpload']");
        if (inputElement) {
            inputElement.value = ''; 
        }
        // Find the container holding both input and button
        const containerElement = inputElement?.closest('div');
        if (containerElement) {
            const inputFile = containerElement.querySelector("input[type='file']");
            if (inputFile) {
                inputFile.value = '';
            }
        }
    }

    const handleVideoUpload = async () => {
        setLoader(true);
        if (!selectedVFile) {
            // alert('Please select a video');
            CustomToast.info('Please select an video to upload')
            return;
        }

        try {
            const result = await apiFunctions.uploadVideo(`${baseUrl}uploadVideo`, selectedVFile);
            setUploadV(false)
            setFileV_path(result.data.file_path)
            if (fileV_path != null) {
                sessionStorage.setItem(getLanguageSpecificKey('videoData'), JSON.stringify(result.data.file_path))
            } else {
                setFileV_path(null);
            }
            setLoader(false);
            CustomToast.success('File uploaded successfully')
        } catch (error) {
            setLoader(false);
            console.error('Video upload error:', error);
            CustomToast.error('Error while uploading file')
        }
    };


    useEffect(() => {

        const intervalId = setInterval(() => {
            setLoader(true);
            const newCourseDetail = sessionStorage.getItem("courseId");
            let courseName = sessionStorage.getItem("courseName")
            setCourseName(courseName)

            if (JSON.stringify(newCourseDetail) !== JSON.stringify(courseID)) {
                console.log(newCourseDetail, JSON.stringify(courseID))
                getCourseDetail(newCourseDetail)
                setCourseId(newCourseDetail)
                setLoader(false);
            }
          
            const isMicroModule = JSON.parse(sessionStorage.getItem("courseDetail"))?.isMicroModule;
            setIsMicroModule(isMicroModule);
            setLoader(false);
            
        }, 1000);
        return () => clearInterval(intervalId);

    }, [courseID]);

    const getCourseDetail = (courseId) => {
        fetchCourseDetail(courseId).then((data) => {
            sessionStorage.setItem("courseDetail", JSON.stringify(data.data))
            if (data.status) {
                setCourseData({
                    duration: data.data.duration,
                    courseTitle: data.data.title,
                    courseTagline: data.data.tagline,
                    skillset: data.data.skillset,
                    additionalEditors: data?.data?.contents?.length > 0 ? data?.data?.contents : ['']
                })
                setPreviewUrl(data.data.image)
                setPreviewUrlB(data.data.banner_image)
                setPreviewDataVUrl(data.data.video)
            }
        }).catch((error) => {
            console.log("error:", error)
        })
    }

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCourseData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleAddEditor = () => {
        setCourseData((prevData) => ({
            ...prevData,
            additionalEditors: [...prevData.additionalEditors, '']
        }));
    };

    const handleAdditionalEditorChange = (editorIndex, data) => {
        setCourseData((prevData) => {
            const updatedEditors = [...prevData.additionalEditors];
            updatedEditors[editorIndex] = data;
            return {
                ...prevData,
                additionalEditors: updatedEditors
            };
        });
    };
    const handleRemoveEditor = (index) => {
        setCourseData((prevData) => {
            const updatedAdditionalEditors = [...prevData.additionalEditors];
            updatedAdditionalEditors.splice(index, 1);
            return {
                ...prevData,
                additionalEditors: updatedAdditionalEditors
            };
        });
    };

    useEffect(() => {
        sessionStorage.setItem('courseData', JSON.stringify(courseData))
    }, [courseData, previewUrl, previewUrl])

    return (<>
        {loader ? <Loader /> : (<>
            <aside className={`course_details_sidebar sidebar px-4 pt-5 ${show ? "review" : " "} `} id="admin-dash-nav">
                <div className='d-flex flex-column justify-content-between h-100 p-3 course_details'>
                    <div className='row'>
                        <h5 className="font-20 mb-4 fw-bold">Upload file</h5>
                        <label className="fw-bold mb-2">Course Thumbnail</label>

                        <div
                            className="border rounded p-3 w-100 position-relative"
                            style={{
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderColor: '#dee2e6',
                            }}
                        >
                            {!previewUrl && !selectedFile ? (
                                <div
                                    className="d-flex flex-column justify-content-center align-items-center w-100"
                                    style={{
                                        minHeight: '150px',
                                        backgroundColor: '#f8f9fa',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                        position: 'relative',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img src="/images/File.svg" alt="file" style={{ width: '40px', marginBottom: '8px' }} />
                                    <p className="m-0 text-muted">Choose File</p>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        onClick={(e) => {
                                            e.target.value = null;
                                        }}
                                        style={{
                                            position: 'absolute',
                                            height: '100%',
                                            width: '100%',
                                            top: 0,
                                            left: 0,
                                            opacity: 0,
                                            cursor: 'pointer',
                                            zIndex: 5,
                                        }}
                                    />
                                </div>
                            ) : (
                                <div
                                    className="position-relative w-100 d-flex justify-content-center align-items-center"
                                    style={{
                                        minHeight: '150px',
                                        backgroundColor: '#f8f9fa',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <img
                                        src={previewUrl}
                                        alt="Preview"
                                        style={{ maxHeight: '140px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                    <button
                                        type="button"
                                        onClick={handleRemoveImage}
                                        className="position-absolute btn btn-link p-0 m-0"
                                        style={{ top: '5px', right: '5px', zIndex: 10 }}
                                    >
                                        <img src="/images/delete.png" alt="remove" style={{
                                            width: '25px',
                                            backgroundColor: '#fff'
                                        }} />
                                    </button>
                                </div>
                            )}

                            {selectedFile && (
                                <>
                                    <p className="text-center mt-3 text-break" style={{ fontSize: '14px', color: '#333' }}>
                                        {selectedFile.name}
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="button"
                                            className="btn btn-primary mt-1 px-5 w-75 py-2"
                                            onClick={handleImageUpload}
                                        >
                                            Upload
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>


                        {!isMicroModule && (
                            <div className='mt-4'>
                                <label className="fw-bold mb-2">Course Banner</label>

                                <div
                                    className="border rounded p-3 w-100 position-relative"
                                    style={{
                                        borderStyle: 'solid',
                                        borderWidth: '1px',
                                        borderColor: '#dee2e6',
                                    }}
                                >
                                    {!previewUrlB && !selectedFileB ? (
                                        <div
                                            className="d-flex flex-column justify-content-center align-items-center w-100"
                                            style={{
                                                minHeight: '150px',
                                                backgroundColor: '#f8f9fa',
                                                border: '2px dashed #ccc',
                                                borderRadius: '8px',
                                                position: 'relative',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <img src="/images/File.svg" alt="file" style={{ width: '40px', marginBottom: '8px' }} />
                                            <p className="m-0 text-muted">Choose File</p>

                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChangeB}
                                                onClick={(e) => {
                                                    e.target.value = null;
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    height: '100%',
                                                    width: '100%',
                                                    top: 0,
                                                    left: 0,
                                                    opacity: 0,
                                                    cursor: 'pointer',
                                                    zIndex: 5,
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className="position-relative w-100 d-flex justify-content-center align-items-center"
                                            style={{
                                                minHeight: '150px',
                                                backgroundColor: '#f8f9fa',
                                                border: '2px dashed #ccc',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <img
                                                src={previewUrlB}
                                                alt="Preview"
                                                style={{ maxHeight: '140px', maxWidth: '100%', objectFit: 'contain' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={handleRemoveImageUploadB}
                                                className="position-absolute btn btn-link p-0 m-0"
                                                style={{ top: '5px', right: '5px', zIndex: 10 }}
                                            >
                                                <img src="/images/delete.png" alt="remove" style={{
                                                    width: '25px',
                                                    backgroundColor: '#fff'
                                                }} />
                                            </button>
                                        </div>
                                    )}

                                    {selectedFileB && (
                                        <>
                                            <p className="text-center mt-3 text-break" style={{ fontSize: '14px', color: '#333' }}>
                                                {selectedFileB.name}
                                            </p>
                                            <div className="d-flex justify-content-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary mt-1 px-5 w-75 py-2"
                                                    onClick={handleImageUploadB}
                                                >
                                                    Upload
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className='mt-4'>
                                    <label className="fw-bold mb-2">Promo Video</label>

                                    <div
                                        className="border rounded p-3 w-100 position-relative"
                                        style={{
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: '#dee2e6',
                                        }}
                                    >
                                        {!previewVUrl && !selectedVFile && !previewDataVUrl ? (
                                            <div
                                                className="d-flex flex-column justify-content-center align-items-center w-100"
                                                style={{
                                                    minHeight: '150px',
                                                    backgroundColor: '#f8f9fa',
                                                    border: '2px dashed #ccc',
                                                    borderRadius: '8px',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <img src="/images/video-player.png" alt="video" style={{ width: '40px', marginBottom: '8px' }} />
                                                <p className="m-0 text-muted">Choose Video File</p>

                                                <input
                                                    type="file"
                                                    accept="video/*"
                                                    onChange={handleFileVChange}
                                                    onClick={(e) => {
                                                        e.target.value = null;
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        height: '100%',
                                                        width: '100%',
                                                        top: 0,
                                                        left: 0,
                                                        opacity: 0,
                                                        cursor: 'pointer',
                                                        zIndex: 5,
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                className="position-relative w-100 d-flex justify-content-center align-items-center"
                                                style={{
                                                    minHeight: '150px',
                                                    backgroundColor: '#f8f9fa',
                                                    border: '2px dashed #ccc',
                                                    borderRadius: '8px',
                                                }}
                                            >
                                                {previewDataVUrl ? (
                                                    <video
                                                        className='w-100'
                                                        controls
                                                        style={{ maxHeight: '140px', borderRadius: '6px' }}
                                                    >
                                                        <source src={previewDataVUrl} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                ) : selectedVFile ? (
                                                    <video
                                                        className='w-100'
                                                        controls
                                                        style={{ maxHeight: '140px', borderRadius: '6px' }}
                                                    >
                                                        <source src={URL.createObjectURL(selectedVFile)} type={selectedVFile.type} />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                ) : null}
                                                
                                                <button
                                                    type="button"
                                                    onClick={handleRemoveVideo}
                                                    className="position-absolute btn btn-link p-0 m-0"
                                                    style={{ top: '5px', right: '5px', zIndex: 10 }}
                                                >
                                                    <img src="/images/delete.png" alt="remove" style={{
                                                        width: '25px',
                                                        backgroundColor: '#fff'
                                                    }} />
                                                </button>
                                            </div>
                                        )}

                                        {selectedVFile && (
                                            <>
                                                <p className="text-center mt-3 text-break" style={{ fontSize: '14px', color: '#333' }}>
                                                    {selectedVFile.name}
                                                </p>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary mt-1 px-5 w-75 py-2"
                                                        onClick={handleVideoUpload}
                                                        disabled={loader}
                                                    >
                                                        {loader ? 'Uploading...' : 'Upload'}
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>)}

                    </div>
                </div>
            </aside>

            <div className='course_main'>

                <form>
                    <div className='row mb-4'>
                        <div className="col-md-6">
                            <label for="courseTitle" className="form-label">{courseName}</label>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className="col-md-6">
                            <label for="courseTitle" className="form-label">Course Title</label>
                            <input type="text" className="form-control" id="courseTitle" placeholder="Safe Workplaces" name="courseTitle" value={courseData.courseTitle}
                                onChange={handleInputChange} />
                        </div>
                        <div className="col-md-6">
                            <label for="courseTagline" className="form-label">Course Tagline</label>
                            <input type="text" className="form-control" id="courseTagline" placeholder="Prevention against Sexual Harassment at Workplace" name="courseTagline" value={courseData.courseTagline}
                                onChange={handleInputChange} />
                        </div>
                    </div>

                    <div className='row mb-4'>
                        <div className="col-md-6">
                            <label for="course_title" className="form-label">Estimate Duration</label>
                            <input type="text" className="form-control" id="course_title" placeholder="60 Mins" name="duration" value={courseData.duration} onChange={handleInputChange} />
                        </div>
                        <div className="col-md-6">
                            <label for="skillset" className="form-label">Skillset</label>
                            <input type="text" className="form-control" id="skillset" placeholder="Use comma to separate skills" name="skillset" value={courseData.skillset}
                                onChange={handleInputChange} />
                        </div>
                    </div>

                    <div className='row'>
                        <div className="col-md-12">
                            <label className='mb-2'>Card Text</label>
                            {courseData.additionalEditors.map((editorContent, index) => (
                                <div key={index} className='mb-4 ckeditor'>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        // config={ editorConfiguration }
                                        data={editorContent}
                                        onChange={(event, editor) => handleAdditionalEditorChange(index, editor.getData())}
                                    />
                                    <button type="button" onClick={() => handleRemoveEditor(index)} className='delete-block'><img src='/images/delete.svg' alt='delete block' /></button>
                                    {/* <button type="button" onClick={() => handleRemoveEditor(index)}>Remove Block</button> */}
                                </div>
                            ))}
                            <button type="button" className='add-block' onClick={handleAddEditor}><span>Add Block</span></button>

                        </div>

                        
                    </div>


                </form>

            </div>
        </>)}
    </>)

}

export default CourseDetails;
